import React from 'react'
import { Box, Typography, Table, TableRow, TableCell, TableBody, TableHead, useTheme, Grid } from '@mui/material'
import { formatCurrency } from '../DealsKanban/aggregateStageTotals'
import RenderServiceIcon from '../RenderServiceIcons/RenderServiceIcon'
import { tableCellStyles, tableHeaderStyles } from '../DealApproval/style'
import { calculateProductsDateRange } from '../../utils/dealCalculations'
import PandaDocViewer from './PandDocViewer'
import { useDealData } from 'api/aws/deals/useDealData'
import { useParams } from 'react-router-dom'

interface IOTotalScheduleProps {
  deal?: any
  totals: any
  hideViewIcon: any
}

const IOTotalSchedule = ({ totals, hideViewIcon }: IOTotalScheduleProps) => {
  const { PK, SK } = useParams()
  const dealId = SK?.split('DEAL_')?.[1]
  const { deal, productRows } = useDealData(PK, SK, dealId)
  const theme = useTheme()
  const {
    dateRange: { start = null, end = null } = {},
  } = deal && Array.isArray(productRows) ? calculateProductsDateRange(productRows) : { dateRange: {} }
  const { totalMonths = 1, allSame = true } =
    deal && Array.isArray(productRows) ? calculateProductsDateRange(productRows) : {}
  // const { allSame } =
  //   deal && Array.isArray(productRows) ? calculateProductsDateRange(productRows) : { totalMonths: 1 }
  // Ensure the deal type is IO
  if (deal.type !== 'IO') {
    return <Typography>This component is only for IO deals</Typography>
  }
  console.log('[IOTotalSchedule] deal: ', deal, 'productRows', productRows)
  // Calculate total IO cost by summing all product costs and multiplying by totalMonths
  // const ioTotal = productRows.reduce((total, product) => total + parseFloat(product.price || 0), 0)
  const ioTotal = deal && deal.totals?.total ? deal.totals.total : deal && deal?.total ? deal?.total : null
  const varyingDateTotal = productRows.reduce((total, product) => {
    const productQty = product?.qty || 1
    const price = product.payer === 'Client' ? parseFloat(String(product.billedPrice || 0)) : parseFloat(String(product.price || 0))
    const rowTotal = price * productQty
    return total + rowTotal // Ensure price is a valid number
  }, 0)

  // Calculate the complete total by multiplying the total cost of products by the total months
  const completeTotal = totalMonths > 0 ? Number(ioTotal || 0) * totalMonths : ioTotal
  return (
    <Grid container spacing={1} sx={{ maxWidth: '80vw' }}>
      <Grid item xs={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={deal && deal.status === 'Completed' ? 1.5 : 2} sx={tableHeaderStyles}>
                {start && end ? `${start} - ${end} | ${totalMonths} mo(s).` : `No Start and End Date`}
              </TableCell>
              {deal && deal.status === 'Completed' && (
                <TableCell colSpan={deal && deal.status === 'Completed' ? 0.5 : 2} sx={tableHeaderStyles}>
                  <Box sx={{ display: hideViewIcon ? 'none' : '' }}>
                    <PandaDocViewer contractId={deal ? deal.contractId : null} />
                  </Box>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {productRows.map((product, idx) => {
              const productRowPrice = product && product.payer === 'Client' ? product.billedPrice : product.price
              return (
                <TableRow key={`${idx}-${product.productName}`}>
                  <TableCell sx={tableCellStyles(theme)}>
                    <RenderServiceIcon service={product.productName} />
                  </TableCell>
                  <TableCell sx={tableCellStyles(theme)}>
                    {' '}
                    <Typography
                      sx={{
                        color: product?.payer === 'Client' ? theme.palette.text.warning : theme.palette.text.primary,
                      }}
                    >
                      {formatCurrency(productRowPrice)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )
            })}
            <TableRow>
              <TableCell
                sx={{
                  ...tableCellStyles(theme),
                  textAlign: 'right',
                  borderRight: 'none',
                }}
                colSpan={1}
              >
                Total IO Cost:
              </TableCell>
              <TableCell
                sx={{
                  ...tableCellStyles(theme),
                  color: 'rgb(50, 187, 130)',
                  borderLeft: 'none',
                }}
                colSpan={1}
              >
                {formatCurrency(allSame ? ioTotal : varyingDateTotal)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  )
}

export default IOTotalSchedule
